document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('.js-gallery-main');
  const thumbs = document.querySelectorAll('.js-gallery-thumb');

  if (!mainImage || thumbs.length === 0) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const large = thumb.dataset.large;
      if (!large) return;

      // ★ ここが重要
      mainImage.src = large;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');

      // active切り替え
      thumbs.forEach(t => t.closest('li').classList.remove('is-active'));
      thumb.closest('li').classList.add('is-active');
    });
  });
});
